namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailOrganizacniJednotkaDenikSsl extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GOrganizacniJednotkaDenikSslReadDto;
        private openFromdenikSsl: boolean;
        private newRecord: boolean;
        private detailObj: DetailOrganizacniJednotkaDenikSslObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailOrganizacniJednotkaDenikSslObj());
            this.detailObj.createBase({
                contentName: "detailOrganizacniJednotkaDenikSsl",
                contentCaption: "jres:33000372", //RC 33000368 : P�i�azen� instance ke konf. skupin�
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            this.detailObj.openFromdenikSsl = this.openFromdenikSsl
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailOrganizacniJednotkaDenikSsl", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailOrganizacniJednotkaDenikSslObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GOrganizacniJednotkaDenikSslReadDto> {
        openFromdenikSsl: boolean

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["ixs_ins"]
        }

        setSxsDetail(): string {
            return this.data.ixs_orj + "#" + this.data.sslden + "#" + this.data.subrada + "#";
        }

        saveData(data: Gordic.AdmIsl.Interface.GOrganizacniJednotkaDenikSslSaveDto, close: boolean) {
            data.NewRecord = this.options.newRecord;
            data.subrada = 1;
            (this.cnt.isl.OrganizacniJednotkaDenikSsl.upsert({ data: data }).get() as any).done((output) => {
                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    this.pendingAction("actSave", true)
                    this.data = output.data;
                    this.metadata = this.data.MetaData;
                    this.updateGridBase().done(() => {
                        this.showSuccessSave(close);
                        if (close == true) {
                            this.closeAction(true).done(() => { this.cnt.close() });
                        } else
                            this.reloadDataBase();
                    })
                } else {
                    this.checkErrors(output.result.errors)
                    this.pendingAction("actSave", false)
                }
            }).fail((err) => {
                this.pendingAction("actSave", false)
            })
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailOrganizacniJednotkaDenikSsl", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.OrganizacniJednotkaDenikSsl.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1} x {2}".format(this.options.contentCaption, (this.data.ixs_orj_txt) ? this.data.ixs_orj_txt : "", (this.data.sslden) ? this.data.sslden : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actEdit*",
                { action: this.cnt.actions.actSave, favorite: true, actionContext: { close: false } },
                "actCancelEdit*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                { caption: "jres:32000161", action: this.cnt.actions.actSave, customClass: "g-button--primary", favorite: true, actionContext: { close: true } },
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            if (this.openFromdenikSsl == true) {
                this.MakeSelectField("sslden", Gordic.Prefabs.Select.sslsden(), {
                    model: "model.sslden=value.sslden",
                    dropdown: false,
                });
                this.MakeSelectField("ixs_orj", Gordic.Prefabs.Select.ginsorj(), {
                    model: "model.ixs_orj=value.ixs_orj",
                    dropdown: false
                });
            } else {
                this.MakeSelectField("ixs_orj", Gordic.Prefabs.Select.ginsorj(), {
                    model: "model.ixs_orj=value.ixs_orj",
                    dropdown: false
                });
                this.MakeSelectField("sslden", Gordic.Prefabs.Select.admsslsden(), {
                    model: "model.sslden=value.sslden",
                    dropdown: false,
                });
            }
            this.MakeSelectField("aktivita", Gordic.Prefabs.Select.gincakt());
            this.MakeField("dat_zmena");
            this.MakeSelectField("zmenu_prov", Gordic.Prefabs.Select.ginszmp(), { model: "model.zmenu_prov=value.ixs_zmp" });
        }
    }
}